// extracted by mini-css-extract-plugin
export default {"paginated":"Paginated_paginated__dyySz","paginated__button":"Paginated_paginated__button__X3sfP","active":"Paginated_active__JOPKt"};